import { useTransactionCertificateStore } from "../../../../store/transaction-certificates.store";

interface FarmTraderOrganicInformation {
    inputFarmTraderOrganicInformationOrder: string;
    inputFarmScNo: string;
    inputFarmTcNo: string;
    inputTraderTCNoForOrganicMaterial: string;
    inputTcOrganicFarmStandards: string;
}

interface TcProductStandardInformation {
    inputTcProductStandardInformationOrder: string;
    inputTcProductStandardLabelGrade: string;
    inputTcProductStandardLabelGradeDescription: string;
    inputTcProductCertifiedWeight: number;
    inputTcProductCertifiedWeightUsed: number;
    productNo: string;
}

interface ProductRawMaterialInformation {
    inputProductRawMaterialInformationOrder: string;
    inputTcProductRawMaterialCode: string;
    inputTcProductRawMaterialCodeDescription: string;
    inputTcProductRawMaterialPercentage: number;
    productNo: string;
}

interface CertifiedRawMaterialWeightUsedInformation {
    inputTcCertifiedRawMaterialCode: string;
    outputTcCertifiedRawMaterialCode: string;
    inputTcCertifiedRawMaterialWeightUsed: string;
    inputTcCertifiedRawMaterialCodeDescription: string;
    outputTcCertifiedRawMaterialCodeDescription: string;
}

interface TcProductInformation {
    inputTcProductInformationOrder: string;
    inputTcProductNo: string;
    inputTcProductArticleNo: string;
    inputTcProductNumberOfUnits: number;
    inputTcProductUnitsMetric: string;
    inputTcProductProductionDate: string;
    inputTcProductCategoryCode: string;
    inputTcProductCategoryCodeDescription: string;
    inputTcProductCategoryUserSpecificTerm: string;
    inputTcProductDetailCode: string;
    inputTcProductDetailCodeDescription: string;
    inputTcProductDetailUserSpecificTerm: string;
    inputTcProductInfoTrimsExcluded: string;
    inputTcProductInfoAssociatedTc: string;
    inputTcProductInfoFiberLength: string;
    inputTcProductInfoYarnCount: string;
    inputTcProductInfoFabricWeightAndConstruct: string;
    inputTcProductInfoFabricWeightOfFinishedProduct: string;
    inputTcProductInfoAdditional: string;
    productId: string;
    inputTcProductStandardInformation: TcProductStandardInformation[];
    inputProductRawMaterialInformation: ProductRawMaterialInformation[];
}

interface InputTcInformation {
    inputTcOrder: string;
    inputTcNo: string;
    inputAtcNo: string; // Added for ATC No field
    tcAssociatedProductNo: string;
    inputTcCbLicensingCode: string;
    inputTcSellerLicenseNo: string;
    inputTcSellerTeId: string;
    inputTcSellerScNo: string;
    inputTcUsdaCompliantFlag: string;
    inputTCFlag: string; // Added for radio field (Y/N)
    inputTcCertifiedRawMaterialWeightUsedInformation: CertifiedRawMaterialWeightUsedInformation[];
    ocsProcessor: string;
    inputFarmTraderOrganicInformation: FarmTraderOrganicInformation[];
    inputTcProductInformation: TcProductInformation[];
}

interface TransformedPayload {
    tcId: string;
    inputTcInformation: InputTcInformation[];
}
// Instead of 'any[]', accept an object
  
export const mapPayload = (data: any, tcId: any, inputTcId?: any,selectedProductIds?: any,selectedInputTcId?: any) => {
    console.log("map", data);
  
    return {
      tcId: tcId,
      ...(inputTcId ? { inputTcId } : {}),
  
      inputTcInformation: [
        {
          inputTcOrder: "1",
          inputTcNo:
            data.ocsProcessorConfig &&
            data.ocsProcessorConfig.tableData &&
            data.ocsProcessorConfig.tableData.length > 0
              ? "na"
              : data.inputTcDetails.inputTCFlag === "Y"
              ? "na"
              : data.inputTcDetails.inputTcNo,
          inputAtcNo:
            data.ocsProcessorConfig &&
            data.ocsProcessorConfig.tableData &&
            data.ocsProcessorConfig.tableData.length > 0
              ? "na"
              : data.inputTcDetails.inputTCFlag === "Y"
              ? "na"
              : data.inputTcDetails.inputAtcNo,
          tcAssociatedProductNo: data.inputTcDetails.tcAssociatedProductNo,
          inputTcCbLicensingCode: data.inputTcDetails.InputCBLicensingCode || "",
          inputTcSellerLicenseNo: data.inputTcDetails.inputTcSellerLicenseNo,
          inputTcSellerTeId: data.inputTcDetails.inputTcSellerTeId,
          inputTcSellerScNo: data.inputTcDetails.inputTcSellerScNo,
          inputTcUsdaCompliantFlag: data.inputTcDetails.inputTcUsdaCompliantFlag,
          inputTCFlag: data.inputTcDetails.inputTCFlag || "N", // Default to "N" if not set
          inputTcCertifiedRawMaterialWeightUsedInformation:
            data.certifiedRawMaterialDetails?.map((item: any) => ({
              inputTcCertifiedRawMaterialCode: item.inputTcCertifiedRawMaterialCode || "",
              outputTcCertifiedRawMaterialCode: item.outputTcCertifiedRawMaterialCode || "",
              inputTcCertifiedRawMaterialWeightUsed: item.inputTcCertifiedRawMaterialWeightUsed || "0",
              inputTcCertifiedRawMaterialCodeDescription: item.inputTcCertifiedRawMaterialCodeDescription || "",
              outputTcCertifiedRawMaterialCodeDescription: item.outputTcCertifiedRawMaterialCodeDescription || "",
            })) || [],
          selectedProductIds: selectedProductIds,
          selectedInputTcId: selectedInputTcId,
          ocsProcessor: data.ocsProcessorConfig.inputTcOCSFirstProcessor || "",
          inputFarmTraderOrganicInformation:
            data.ocsProcessorConfig.tableData.map(
              (proc: {
                inputFarmSCNo: any;
                inputFarmTCNo: any;
                inputTraderTCNoForOrganicMaterial: any;
                inputTCOrganicFarmStandards: any;
                tcProductRawMaterialOrder: number;
              }, idx: number) => ({
                inputFarmTraderOrganicInformationOrder: (idx + 1).toString(),
                inputFarmScNo: proc.inputFarmSCNo,
                inputFarmTcNo: proc.inputFarmTCNo,
                inputTraderTCNoForOrganicMaterial:
                  proc.inputTraderTCNoForOrganicMaterial,
                inputTcOrganicFarmStandards: proc.inputTCOrganicFarmStandards,
              })
            ),
          inputTcProductInformation: data.combinedProductDetails.products.map(
            (product: any, idx: number) => ({
              inputTcProductInformationOrder: (idx + 1).toString(),
              inputTcProductNo: product.inputTcProductNo || "",
              inputTcProductArticleNo: product.inputTcProductArticleNo || "",
              inputTcProductNumberOfUnits: parseFloat(product.inputTcProductNumberOfUnits) || 0,
              inputTcProductUnitsMetric: product.inputTcProductUnitsMetric || "",
              inputTcProductProductionDate: product.inputTcProductProductionDate || "",
              inputTcProductCategoryCode: product.inputTcProductCategoryCode || "",
              inputTcProductCategoryCodeDescription: useTransactionCertificateStore.getState().getProductCategoriesStore.find((option: any) => option.value === product.inputTcProductCategoryCode)?.label || "",
              inputTcProductCategoryUserSpecificTerm: product.inputTcProductCategoryUserSpecificTerm || "",
              inputTcProductDetailCode: product.inputTcProductDetailCode || "",
              inputTcProductDetailCodeDescription: useTransactionCertificateStore.getState().getProductDetailCodeStore.find((option: any) => option.value === product.inputTcProductDetailCode)?.label || "",
              inputTcProductDetailUserSpecificTerm: product.inputTcProductDetailUserSpecificTerm || "",
              inputTcProductInfoTrimsExcluded: product.inputTcProductInfoTrimsExcluded || "",
              inputTcProductInfoAssociatedTc: product.inputTcProductInfoAssociatedTc || "",
              inputTcProductInfoFiberLength: product.inputTcProductInfoFiberLength || "",
              inputTcProductInfoYarnCount: product.inputTcProductInfoYarnCount || "",
              inputTcProductInfoFabricWeightAndConstruct: product.inputTcProductInfoFabricWeightAndConstruct || "",
              inputTcProductInfoFabricWeightOfFinishedProduct: product.inputTcProductInfoFabricWeightOfFinishedProduct || "",
              inputTcProductInfoAdditional: product.inputTcProductInfoAdditional || "",
              productId: product.productId || product.id || "",
              inputTcProductStandardInformation:
                data.inputTcProductStandardDetails
                  .filter((stdInfo: any) => stdInfo.productNo === product.inputTcProductNo)
                  .map(
                    (
                      stdInfo: {
                        standardLabelGrade: any;
                        certifiedWeight: string;
                        certifiedWeightUsed: string;
                        productNo: string;
                      },
                      stdIdx: number
                    ) => ({
                      inputTcProductStandardInformationOrder: (stdIdx + 1).toString(),
                      inputTcProductStandardLabelGrade:
                        stdInfo.standardLabelGrade || "",
                      inputTcProductStandardLabelGradeDescription: useTransactionCertificateStore.getState().getLabelGrades.find((option: any) => option.value === stdInfo.standardLabelGrade)?.label || "",
                      inputTcProductCertifiedWeight: (stdInfo.certifiedWeight && stdInfo.certifiedWeight!=="")?
                      parseFloat(stdInfo.certifiedWeight) :0,
                      inputTcProductCertifiedWeightUsed: (stdInfo.certifiedWeightUsed && stdInfo.certifiedWeightUsed!=="")?
                      parseFloat(stdInfo.certifiedWeightUsed) :0,
                      productNo: product.inputTcProductNo || "",
                    })
                  ),
              inputProductRawMaterialInformation: data.rawMaterialDetails
                .filter((rawMaterial: any) => rawMaterial.tcProductNo === product.inputTcProductNo)
                .map(
                  (rawMaterial: {
                    tcProductRawMaterialOrder: { toString: () => any };
                    tcProductRawMaterialCode: any;
                    tcProductRawMaterialPercentage: string;
                    tcProductNo: string;
                  }, rawIdx: number) => ({
                    inputProductRawMaterialInformationOrder:
                      rawMaterial.tcProductRawMaterialOrder.toString(),
                    inputTcProductRawMaterialCode:
                      rawMaterial.tcProductRawMaterialCode,
                    inputTcProductRawMaterialCodeDescription: useTransactionCertificateStore.getState().getRawMtrlCodes.find((option: any) => option.value === rawMaterial.tcProductRawMaterialCode)?.label || "",
                    inputTcProductRawMaterialPercentage: parseFloat(
                      rawMaterial.tcProductRawMaterialPercentage
                    ),
                    productNo: product.inputTcProductNo || "",
                  })
                ),
            })
          ),
        },
      ],
    };
  };
  
export const reverseMapPayload = (payload: any) => {
    const { tcId, inputTcInformation } = payload;

    const data = inputTcInformation.map((inputItem: any) => ({
        tcProductComponentOrder: inputItem.inputTcOrder,
        inputTcNo: inputItem.inputTcNo,
        inputAtcNo: inputItem.inputAtcNo, // Added for ATC No field
        tcAssociatedProdcutNo: inputItem.tcAssociatedProductNo,
        inputTcSellerLicenseNo: inputItem.inputTcSellerLicenseNo,
        inputTcSellerTeId: inputItem.inputTcSellerTeId,
        InputCBLicensingCode: inputItem.inputTcCbLicensingCode,
        inputTcSellerScNo: inputItem.inputTcSellerScNo,
        inputTcUsdaCompliantFlag: inputItem.inputTcUsdaCompliantFlag,
        inputTCFlag: inputItem.inputTCFlag || "N", // Map the new field name
        inputTcCertifiedWeightUsed: inputItem.inputTcCertifiedRawMaterialWeightUsedInformation?.map((item: any) => ({
          inputTcCertifiedRawMaterialCode: item.inputTcCertifiedRawMaterialCode || "",
          outputTcCertifiedRawMaterialCode: item.outputTcCertifiedRawMaterialCode || "",
          inputTcCertifiedRawMaterialWeightUsed: item.inputTcCertifiedRawMaterialWeightUsed || 0,
          inputTcCertifiedRawMaterialCodeDescription: item.inputTcCertifiedRawMaterialCodeDescription || "",
          outputTcCertifiedRawMaterialCodeDescription: item.outputTcCertifiedRawMaterialCodeDescription || "",
        })) || [],
        "input-tc-ocs-processor": inputItem.inputFarmTraderOrganicInformation.map((farmItem: any) => ({
            tcProductRawMaterialOrder: farmItem.inputFarmTraderOrganicInformationOrder,
            inputFarmSCNo: farmItem.inputFarmScNo,
            inputFarmTCNo: farmItem.inputFarmTcNo,
            inputTraderTCNoForOrganicMaterial: farmItem.inputTraderTCNoForOrganicMaterial,
            inputTCOrganicFarmStandards: farmItem.inputTcOrganicFarmStandards,
        })),
        inputTcProductNo: inputItem.inputTcProductInformation[0]?.inputTcProductNo,
        inputTcProductArticleNo: inputItem.inputTcProductInformation[0]?.inputTcProductArticleNo,
        inputTcProductNumberOfUnits: inputItem.inputTcProductInformation[0]?.inputTcProductNumberOfUnits,
        inputTcProductUnitsMetric: inputItem.inputTcProductInformation[0]?.inputTcProductUnitsMetric,
        inputTcProductProductionDate: inputItem.inputTcProductInformation[0]?.inputTcProductProductionDate,
        inputTcProductCategoryCode: inputItem.inputTcProductInformation[0]?.inputTcProductCategoryCode,
        inputTcProductCategoryUserSpecificTerm: inputItem.inputTcProductInformation[0]?.inputTcProductCategoryUserSpecificTerm,
        inputTcProductDetailCode: inputItem.inputTcProductInformation[0]?.inputTcProductDetailCode,
        inputTcProductDetailUserSpecificTerm: inputItem.inputTcProductInformation[0]?.inputTcProductDetailUserSpecificTerm,
        inputTcProductInfoTrimsExcluded: inputItem.inputTcProductInformation[0]?.inputTcProductInfoTrimsExcluded,
        inputTcProductInfoAssociatedTc: inputItem.inputTcProductInformation[0]?.inputTcProductInfoAssociatedTc,
        inputTcProductInfoFiberLength: inputItem.inputTcProductInformation[0]?.inputTcProductInfoFiberLength,
        inputTcProductInfoYarnCount: inputItem.inputTcProductInformation[0]?.inputTcProductInfoYarnCount,
        inputTcProductInfoFabricWeightAndConstruct: inputItem.inputTcProductInformation[0]?.inputTcProductInfoFabricWeightAndConstruct,
        inputTcProductInfoFabricWeightOfFinishedProduct: inputItem.inputTcProductInformation[0]?.inputTcProductInfoFabricWeightOfFinishedProduct,
        inputTcProductInfoAdditional: inputItem.inputTcProductInformation[0]?.inputTcProductInfoAdditional,
        "tc-std-info": inputItem.inputTcProductInformation[0]?.inputTcProductStandardInformation.map((stdItem: any) => ({
            standardLabelGrade: stdItem.inputTcProductStandardLabelGrade,
            certifiedWeight: stdItem.inputTcProductCertifiedWeight,
            certifiedWeightUsed: stdItem.inputTcProductCertifiedWeightUsed,
        })),
        "raw-materials-info": inputItem.inputTcProductInformation[0]?.inputProductRawMaterialInformation.map((rawItem: any) => ({
            tcProductRawMaterialOrder: rawItem.inputProductRawMaterialInformationOrder,
            tcProductRawMaterialCode: rawItem.inputTcProductRawMaterialCode,
            tcProductRawMaterialPercentage: rawItem.inputTcProductRawMaterialPercentage,
        })),
    }));

    return { tcId, data };
};